import { token } from "@zenchef/styled-system/tokens";
import useWindowSize from "./useWindowSize";

export const calculateIsTabletScreen = (windowWidth: number) =>
  windowWidth < parseInt(token("breakpoints.sm"), 10);

const useIsTabletScreen = () => {
  const { width: windowWidth } = useWindowSize();

  return calculateIsTabletScreen(windowWidth);
};

export default useIsTabletScreen;
